import { TextField, ThemeProvider, createTheme } from "@mui/material";
import React, { useEffect, useState, useMemo, useRef } from "react";
import axios from "axios";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { common_axios } from "../../../App";
import ReactTable from "./ReactTable";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import SingleTableEntry from "./SingleTableEntry";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import Autocomplete from "@mui/material/Autocomplete";
import Swal from "sweetalert2";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import Stack from "@mui/material/Stack";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import moment from "moment";
const BlackList = ({ resetValue }) => {
  //.........useState..................//
  const [value, setValue] = React.useState(null);

  const [data, setData] = useState([]);
  const [open, setOpen] = useState();
  const [hide, setHide] = useState(true);
  const [phoneNumber1, setPhoneNumber1] = useState("");
  const [error, seterror] = useState(false);
  const [hideSkeleton1, setHideSkeleton1] = useState();
  const [accountcountryid, setAccountCountryId] = useState("");
  const [accountidvalue, setAccountIdValue] = useState([]);
  const [userState, setUserState] = React.useState([]);

  const handleChangeCountryAccount = (e) => {
    setAccountCountryId(e.target.value);
  };
  const customId1 = "custom-id-yess";
  // console.log("gggggg", value);
  const Reset = () => {
    setPhoneNumber1("");
  };
  const handlechangenumber = (e) => {
    // console.log("phonenumber", e.target.value);
    var target = e.target.value;
    var length = target.length;
    //  console.log("targetlength",length)
    // let addharVal = target.value.replace(/\s/g, "");
    if (length > 9) {
      target = target.slice(0, 10);
      target = target.replace(/[^\dA-Z]/g, "");
      // console.log("lengthhhhh", target);
      seterror(false);
    } else {
      seterror(true);
    }
    setPhoneNumber1(target);
  };
  // ...................................Theme Provider....................................//
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  // .....................................Formik............................................//
  const initialValues = {
    msisdn: "",
  };





  const validationSchema = yup.object({
    msisdn: yup
      .string()
       .min(8, "Minimum length of a mobile number is 8 digits")
       .max(8, "Maximum length of mobile number is 8 digits")
      .required("Required"),
  });
  const formik = useFormik({
    initialValues: initialValues,
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      seterror(false);
      BlackListPost(values);
    },
  });
  // ......................................Post API.......................................//
  async function BlackListPost(values) {
    let userIds = [];
    for (let i = 0; i < userState.length; i++) {
      if (userState[i].userId != "all") {
        userIds[i] = userState[i].userId;
      }
    }
    try {
      setOpen(true);
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/dnd/v2/save/single/msisdn`,

        // "http://192.168.167.66:5002/v1/DND/msisdin",

        // {
        //   msisdn: values.msisdn,
        //   // msisdn: phoneNumber1,
        // }
        {
          dndRequest: {
            msisdn: String("222" + values.msisdn),
            // uid: userIds,
            uid:
              JSON.parse(localStorage.getItem("Sidebaritems")).name ==
              "ROLE_SUPER_ADMIN"
                ? userIds?.length > 0
                  ? userIds
                  : null
                : [JSON.parse(localStorage.getItem("items")).uid],
            // allFlag: false,
            // allFlag: userIds?.length > 0 ? true : false,
            //  allFlag:userIds?.length > 0 ? false : true , 
            flag: JSON.parse(localStorage.getItem("Sidebaritems")).name ==
          "ROLE_SUPER_ADMIN" ? userIds?.length > 0 ? false : true
          : false,
            createdBy: localStorage.getItem("usernamedisplayed"),
            upto: moment(value)?.format(
              "YYYY-MM-DD HH:mm:ss"
            ),
          },
        }
      ); 
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setHide(false);
        setPhoneNumber1("");
setValue(null)
        setData([
          ...data,
          {
            msisdn: res.data.msisdn,
            message: "Mobile Number registered as DND",

            uploadDate: res.data.uploadDate,
            upto:res.data.upto,
          },
        ]);
        setUserState([]);
        formik.handleReset();
        Swal.fire({
          icon: "success",
          //  title: "Oops...",
          text: "Mobile number added successfully!!",
        });
        values.msisdn = "";
      } else if (res.data.statusDescription.statusCode == 202) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Mobile number already exists !!",
        });
        setOpen(false);
      } else {
        setOpen(false);
      
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
        });
      }
    } catch (error) {
      setOpen(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }
  // ............................................................................................//
  async function AccountId() {
    try {
      setHideSkeleton1(true);
      const result = await common_axios(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/user/data`,
    
      );
      if (result.data.statusDescription.statusCode == 200) {
        setHideSkeleton1(false);
        let x = [
          {
            userId: "all",
            userName: "All",
          },
        ];
        let temp = [...x, ...result.data.accountId];
        // temp.push({
        //   userId: 0,
        //   userName: "All",
        // });
        setAccountIdValue(temp);
      } else {
        setHideSkeleton1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
        });
      }
    } catch (error) {
      setHideSkeleton1(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
      });
    }
  }
  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN"
    ) {
      AccountId();
    }
  }, []);
  useEffect(() => {
    formik.handleReset();
    seterror(false);

    setUserState([]);
  }, [resetValue]);

  // --------------------------------Blacklist calender------------------------------
  const onKeyDown = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    setValue(new Date());
  }, []);

  // ----------------------------------ENd calender------------------------------------
  return (
    <>
      <div>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
        >
          <Loader />
        </Backdrop>
      </div>
      <div className="card-body">
        <div className="card shadow-none border bg_blue mt-4">
          <span className="badge rounded-pill bg-primary mt-n3 ms-5">
            {/* Add Number */}
            Enter Mobile Number
          </span>
          <div className="card-body text-lg-start text-center" id="msisdn">
            <form
              onSubmit={formik.handleSubmit}
              role="form"
              className="text-start"
            >
              <ThemeProvider theme={theme}>
                <div className="row mt-4">
                  <div className="col-md-3" id="inp_merge">
                    <div className="d-flex">
                      <input className="inpt_width" disabled value="+222" />
                      <TextField
                        className="m-0"
                        style={{
                          borderRadius: "4px",
                        }}
                        // type="number"
                        type="string"
                        label="Mobile Number"
                        name="msisdn"
                        variant="outlined"
                        // value={number}
                        size="small"
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip
                                title="Please enter a valid phone number"
                                placement="top"
                                arrow
                                sx={{ color: "#85CBF2" }}
                              >
                                <InfoIcon />
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                        onChange={formik.handleChange}
                        value={formik.values.msisdn}
                        error={
                          formik.touched.msisdn && Boolean(formik.errors.msisdn)
                        }
                        helperText={
                          formik.touched.msisdn && formik.errors.msisdn
                        }
                        onInput={(e) => {
                          // e.target.value = Math.max(0, parseInt(e.target.value))
                          //   .toString()
                          //   .slice(0, 8);
                          e.target.value = e.target.value.slice(0, 8);
                        }}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;

                          if (
                            (keyCode >= 48 && keyCode <= 57) ||
                            keyCode == 13
                          ) {
                            seterror(false);
                          } else {
                            event.preventDefault();
                            seterror(true);
                          }
                        }}
                      />
                    </div>
                  </div>
                  {JSON.parse(localStorage.getItem("Sidebaritems")).name ==
                  "ROLE_SUPER_ADMIN" ? (
                    <>
                      {hideSkeleton1 == true ? (
                        <>
                          <Box sx={{ width: "25%" }}>
                            <Skeleton />
                            <Skeleton animation="wave" />
                            {/* <Skeleton animation={false} /> */}
                          </Box>
                        </>
                      ) : (
                        <>
                          <div className="col-md-3">
                            <Autocomplete
                              aria-required
                              // disabled={MenuItemPhoneBook==undefined}
                              size="small"
                              fullWidth
                              value={userState}
                              onChange={(e, val) => {
                                setUserState(val);
                              }}
                              multiple
                              limitTags={2}
                              id="multiple-limit-tags"
                              options={accountidvalue}
                              getOptionDisabled={(option) =>
                                userState?.[0]
                                  ? userState?.[0]?.userName === "All"
                                    ? option.userName !== "All"
                                    : option.userName === "All"
                                  : null
                              }
                              
                              getOptionLabel={(option) => option?.userName}
                              // defaultValue={mappingArray}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  fullWidth
                                  {...params}
                                  label="User Name List"
                        
                                />
                              )}
                            />
                          </div>
                        </>
                      )}
                      <div className="col-md-3" id="calendar_upto">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Stack spacing={3}>
                        <DesktopDatePicker
                          disablePast 
                          label="Valid Upto"
                          value={value}
                          // minDate={startDate}

                          onChange={(newValue) => {
                            setValue(newValue.$d);
                          }}
                          renderInput={(params) => (
                            <TextField
                              onKeyDown={onKeyDown}
                              {...params}
                              helperText={"(Date time format mm/dd/yyyy"}
                            />
                          )}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </div>
                      <div className="col-md-3">
                        <button
                          type="submit"
                          disabled={
                            formik?.values?.msisdn === "" ||
                            userState?.length == 0 ||
                            value== null
                          }
                          className="btn green_UP btn_SIZE w_btn m-0 ms-3 btn_w8"
                          //  onClick={BlackListPost}
                        >
                          Add
                          {/* <AddRoundedIcon style={{ fontSize: "19px" }} /> */}
                        </button>

                        <button
                          // onClick={formik.resetForm}
                          type="button"
                          className="btn resetBtn_UP m-0 ms-3 w_btn btn_w8 btnReset btn_SIZE"
                          // onClick={Reset}
                          onClick={() => {
                            formik.resetForm();
                            seterror(false);
                            setUserState([]);
                            setValue(null)

                          }}
                        >
                          Reset
                      
                          {/* <SettingsBackupRestoreRoundedIcon
                            style={{ fontSize: "17px" }}
                          />{" "} */}
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-md-3">
                        <TextField
                          required
                          disabled
                          className="w-100"
                          label="Name"
                          // name="name"
                          variant="outlined"
                          size="small"
                          value={localStorage.getItem("usernamedisplayed")}
                          type="text"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <Tooltip
                                  title="Name"
                                  placement="top"
                                  arrow
                                  sx={{ color: "#85CBF2" }}
                                >
                                  <InfoIcon />
                                </Tooltip>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>

                      <div className="col-md-3" id="calendar_upto">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <Stack spacing={3}>
                        <DesktopDatePicker
                          disablePast style={{marginTop:"-0.5rem !important"}}
                          label="Valid Upto"
                          value={value}
                          // minDate={startDate}

                          onChange={(newValue) => {
                            setValue(newValue.$d);
                          }}
                          renderInput={(params) => (
                            <TextField
                              onKeyDown={onKeyDown}
                              {...params}
                              helperText={"(Date time format mm/dd/yyyy"}
                            />
                          )}
                        />
                      </Stack>
                    </LocalizationProvider>
                  </div>
                      <div className="col-md-3">
                        <button
                          type="submit"
                          className="btn green_UP w_btn m-0 ms-3 btn_w8"
                          disabled={
                            formik?.values?.msisdn === "" ||
                           
                            value== null
                          }
                        >
                          Add
                          {/* <AddRoundedIcon style={{ fontSize: "19px" }} /> */}
                        </button>

                        <button
                          type="button"
                          className="btn resetBtn_UP m-0 ms-3 w_btn btn_w8 btnReset"
                          onClick={() => {
                            formik.resetForm();
                            seterror(false);
                            setUserState([]);
                            setValue(null)

                          }}
                        >
                          Reset
                          {/* <SettingsBackupRestoreRoundedIcon
                            style={{ fontSize: "17px" }}
                          />{" "} */}
                        </button>
                      </div>
                    </>
                  )}

                  <div className="row">
                    {error == true ? (
                      <>
                        <p style={{ color: "red" }}>
                          Only Numbers Are Allowed!!
                        </p>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  
                </div>
              </ThemeProvider>
            </form>
          </div>
        </div>
        {hide == true ? (
          <></>
        ) : (
          <>
            <div>
              <SingleTableEntry data1={data} resetValue={resetValue} />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default BlackList;
